'use client'

import { SessionProvider } from 'next-auth/react'

/**
 * NextAuth SessionProvider wrapper
 *
 * Provides NextAuth session context to client components.
 * Required for:
 * - signIn() / signOut() functions
 * - useSession() hook for client-side auth state
 *
 * Session is stored as JWT in httpOnly cookie (next-auth.session-token).
 * Server reads JWT via getServerSession(), client via useSession().
 */
export default function AuthProvider({ children }) {
    return (
        <SessionProvider>
            {children}
        </SessionProvider>
    )
}
